import { BUILD_ENV as BUILD_ENV_IMPORT, BUILD_DEPLOYED_VERSION } from './buildConfig';
import { getAllProducts, LendAPIProductType } from './lendAPIConfig.types';

export const BUILD_ENV = BUILD_ENV_IMPORT;

export const DEFAULT_SOURCE_ID = 0;
export const GOODSAM_SOURCE_ID = 102565;
export const BOAT_US_SOURCE_ID = 101397;
export const BOAT_ZON_SOURCE_ID = 101392;
export const BOAT_TRADER_SOURCE_ID = 101458;
export const YACHTWORLD_SOURCE_ID = 101442;
export const BOATSDOTCOM_SOURCE_ID = 101460;
export const BOATWIZARD_SOURCE_ID = 108653;
export const RVSHARE_SOURCE_ID = 802570;
export const LENDINGTREE_SOURCE_ID = 601882;
export const PRIORITY_RV_NETWORK_SOURCE_ID = 202736;
export const SUN_COUNTRY_SOURCE_ID = 301568;
export const KNOT10_SOURCE_ID = 301579;
export const CRUISING_YACHT_SOURCE_ID = 301476;
export const JEFF_BROWN_YACHTS_SOURCE_ID = 301475;
export const FIRESTORE_TEST_UPLOADER_SOURCE_ID = 302476;

export const LOAN_AMOUNT_FOR_FINANCIAL_STATEMENT = 150000;

export const INTERNAL_REFERRAL_MEDIUM = 'internalreferral';

export const OPERATION_HOURS_DEFAULT = 'Mon - Fri: 8:30am - 5pm EST';

export const DEFAULT_KAMELEOON_SITEKEY = 'uk33jcty1m';

export const TRIDENT_KAMELEOON_GCP_API_KEY = '6b3c3393-dfb7-4d10-997e-5c480d83a25c';

export const PROD_KAMELEOON_GCP_FUNCTION_URL = `https://us-central1-trident-funding.cloudfunctions.net/loadKameleoonData?apiKey=${TRIDENT_KAMELEOON_GCP_API_KEY}`;
export const STAGE_KAMELEOON_GCP_FUNCTION_URL = `https://us-central1-stage-trident.cloudfunctions.net/loadKameleoonData?apiKey=${TRIDENT_KAMELEOON_GCP_API_KEY}`;

export const PROD_TRIDENT_API_URL = 'https://api.tridentfunding.com';
export const QA_TRIDENT_API_URL = 'https://api.qa.tridentfunding.com';

export const BT_COGNITO_CLIENT_ID_QA = '6gs17hlc84ltrm3o29vulqsgj';
export const BT_COGNITO_CLIENT_ID_PROD = '2h1dtd3hf66c5gu5mrhdtc7ci0';
export const RECORD_FINANCE_IDENTITY_PATH = '/record-finance-identity';

export const SEND_CUSTOM_ITERABLE_EVENT_PATH = '/sendCustomEventToIterable';
export const PROCESS_RESUME_LINK_PATH = '/processResumeLink';
// Each environment provisions its own separate API Gateway usage-plan key (terraform-stack-trident
// TRIDENT-1017, aws_api_gateway_api_key.sendCustomIterableEventApiKey) — mirrors PROD_TRIDENT_API_URL/
// QA_TRIDENT_API_URL's env split.
export const QA_SEND_CUSTOM_ITERABLE_EVENT_API_KEY = 'EnXp3SLbbl17vPzxaKsUq2yIxh9YF5ut5N79WVk3';
export const PROD_SEND_CUSTOM_ITERABLE_EVENT_API_KEY = 'qbDQOQFxmhe7nFvXyxCx1ozfLkpuajC8OuI14PUj';

export const LEND_API_ORIGIN = 'https://app.lendapi.com';
export const LEND_API_ROUTE_PREFIX = '/loan-application/';
export const LENDAPI_APPLICATION_HEADER_VALUE_PROPS: string[] = [
  '24hrs Approval',
  "We'll Compare 15 Marine Lenders",
  'Secure Encryption',
];
export const PREQUAL_ROUTE_PATH = '/prequal';
// Same productId/productSlug in every environment: this is the `prodTestingInQA`-tagged
// combined product (see lendAPIConfig.json), so non-prod loads the real production LendAPI
// config via `prodTesting=true` (added in PreQualLandingRoute) instead of a QA-only product.
export const PREQUAL_LANDING_COMBINED_TARGET_URL = '/loan-application/combined/1044/OFEW5N3V_468/';
export const MAX_IFRAME_HEIGHT = 10000; // Increased for signature pages

export const BOATTRADER_LEAD = 'boattrader';
export const SALESFORCE_LEAD = 'salesforce';

export const PREQUAL_MINIMUM_SCORE = 650;

export const PROD_BASE_SALESFORCE_URL = 'https://boatsgroup.lightning.force.com';
export const QA_BASE_SALESFORCE_URL = 'https://boatsgroup--qa.sandbox.lightning.force.com';

export const PROD_DOC_UPLOAD_URL = 'https://boatsgroup.my.salesforce-sites.com';
export const QA_DOC_UPLOAD_URL = 'https://boatsgroup--qa.sandbox.my.salesforce-sites.com';

export const APP_ORIGIN_LENDAPI = 'LendAPI';
export const APP_ORIGIN_LENDAPI_FULL_APP = 'LendAPI Full App';
export const APP_ORIGIN_LENDAPI_COMBINED = 'LendAPI Combined';
export const APP_ORIGIN_DYNAMIC_APP = 'Dynamic App';

export const LENDAPI_COMBINED_FUNNEL_FROM_PARAM = 'lendAPICombinedFunnel';
export const MY_APPLICATIONS_PATH = '/profile/apps';

// Bare BoatTrader origins (no path), used as postMessage targetOrigin values —
// kept separate from the path-bearing BOATTRADER_BOAT_LOANS_URL/BOATTRADER_COMBINED_FUNNEL_URL
// below since postMessage requires an exact origin, not a full URL.
export const BOATTRADER_ORIGIN = 'https://www.boattrader.com';
export const BOATTRADER_QA_ORIGIN = 'https://www.qa.boattrader.com';

// QA/production pairs kept as their own exports (rather than folded straight into the
// BUILD_ENV-ternary below) so other modules — e.g. portalBranding.ts, which picks
// QA vs. production at runtime via isProduction() — can reference the same literals
// without redeclaring them.
export const BOATTRADER_BOAT_LOANS_URL_QA = 'https://www.qa.boattrader.com/boat-loans/';
export const BOATTRADER_BOAT_LOANS_URL_PROD = 'https://www.boattrader.com/boat-loans/';

export const BOATTRADER_COMBINED_FUNNEL_URL_QA =
  'https://www.qa.boattrader.com/boat-loans/apply/loan-application/combined/1044/OFEW5N3V_468/?source=101458&purpose=Boat&prodTesting=true';
export const BOATTRADER_COMBINED_FUNNEL_URL_PROD =
  'https://www.boattrader.com/boat-loans/apply/loan-application/combined/1044/OFEW5N3V_468/?source=101458&purpose=Boat';

export const BOATTRADER_BOAT_LOANS_URL =
  BUILD_ENV === 'production' ? BOATTRADER_BOAT_LOANS_URL_PROD : BOATTRADER_BOAT_LOANS_URL_QA;

export const BOATTRADER_COMBINED_FUNNEL_URL =
  BUILD_ENV === 'production'
    ? BOATTRADER_COMBINED_FUNNEL_URL_PROD
    : BOATTRADER_COMBINED_FUNNEL_URL_QA;

export const DEFAULT_PREQUAL_APR_DISCLAIMER =
  '*Estimated APR, or Annual Percentage Rate, is the annual cost of the loan, which includes other charges and fees. Actual rate and term can vary depending on credit history, collateral type, age of collateral, loan amount, loan term, loan to value, vessel registration type (LLC/Trust), state of residency and other criteria. Rates and terms may vary and are subject to change without notice. Credit score can vary depending on the credit reporting agency. Payment example: A $76,000 loan for the purchase of a recreational use vessel for 20 years with a fixed rate of 4.12% would have an estimated APR of 4.12% and 240 monthly payments of $467.05.';

export const PUBLIC_URL = process.env.PUBLIC_URL || '';

export const SALESFORCE_SELLER_ACCOUNT_LIST_URL_PROD =
  'https://trident-funding.web.app/SalesforceSellerAccountList.json';
export const SALESFORCE_SELLER_ACCOUNT_LIST_URL_STAGE =
  'https://stage-trident.web.app/SalesforceSellerAccountList.json';

export const DEFAULT_FAVICON_URL = `${PUBLIC_URL}/static/trident/logo-tf.png`;
export const DEFAULT_LOGO_URL = `${PUBLIC_URL}/static/trident/logo-head-mobile.png`;
export const SOURCE_FAVICONS_FIREBASE_CLOUD_STORAGE_FOLDER = 'trident-funnel-favicons/';
export const SOURCE_LOGOS_FIREBASE_CLOUD_STORAGE_FOLDER = 'trident-funnel-logos/';
export const MIN_TIME_TO_CREATE_NEW_GENERIC_LEAD = 7 * 24 * 60 * 60 * 1000; // 7 days
export const INIT_DATA_FIREBASE_LOGO_URL =
  'https://firebasestorage.googleapis.com/v0/b/stage-trident.appspot.com/o/trident-funnel-logos%2Finitdata-default-logo.png?alt=media&token=80b0a815-c7e9-4db1-b70f-8f057b195cd1';
export const INIT_DATA_FIREBASE_FAVICON_URL =
  'https://firebasestorage.googleapis.com/v0/b/stage-trident.appspot.com/o/trident-funnel-favicons%2Finitdata-default-favicon.png?alt=media&token=02a1a682-30c1-4a62-aa25-80f5ecb9da2b';

export const DEFAULT_THEME = {
  colors: {
    // Default Button
    defaultButtonBackground: '#FFF',
    defaultButtonBorder: '#D9D9D9',
    defaultButtonColor: '#384A68',
    defaultButtonHoverBackground: '#4972C9',
    defaultButtonHoverBorder: '#4972C9',
    defaultButtonHoverColor: '#FFF',

    // Primary Button
    primaryButtonBackground: '#4972c9',
    primaryButtonBorder: '#4972c9',
    primaryButtonText: '#ffffff',
    primaryButtonHoverBackground: '#1944a5',
    primaryButtonHoverBorder: '#1944a5',
    primaryButtonHoverText: '#ffffff',

    // Login Button
    loginButtonBackground: '#18223b',
    loginButtonBorder: '#ffffff',
    loginButtonText: '#ffffff',
    loginButtonHoverBackground: '#ffffff',
    loginButtonHoverBorder: '#ffffff',
    loginButtonHoverText: '#18223b',

    // Radio Button
    radioButtonSelectedBackground: '#5CB85C33',
    radioButtonSelectedBorder: '#5CB85C',

    // Other
    footer: '#18223b',
    header: '#18223b',
    reviewStepHeader: '#3a4c68',
    sectionBar: '#bdc3c7',
    selectionBackground: '#384a68',
    progressBar: '#5CB85C',

    // StepFooter
    stepFooterBackground: '#f5fafe',
    stepFooterBorder: '#c4c8cb',
    stepFooterIconColor: '#2566b0',
  },
  logo: DEFAULT_LOGO_URL,
  marketingWebsiteUrl: 'https://www.tridentfunding.com/',
  showMemberField: false,
  favicon: DEFAULT_FAVICON_URL,
};

export const THEME_CSS_VARS_RELATION: [string, string][] = [
  // Default Button
  ['default-button-background-color', 'defaultButtonBackground'],
  ['default-button-border-color', 'defaultButtonBorder'],
  ['default-button-text-color', 'defaultButtonColor'],
  ['default-button-hover-background-color', 'defaultButtonHoverBackground'],
  ['default-button-hover-border-color', 'defaultButtonHoverBorder'],
  ['default-button-hover-text-color', 'defaultButtonHoverColor'],

  // Primary Button
  ['primary-button-background-color', 'primaryButtonBackground'],
  ['primary-button-border-color', 'primaryButtonBorder'],
  ['primary-button-text-color', 'primaryButtonText'],
  ['primary-button-hover-background-color', 'primaryButtonHoverBackground'],
  ['primary-button-hover-border-color', 'primaryButtonHoverBorder'],
  ['primary-button-hover-text-color', 'primaryButtonHoverText'],

  // Login Button
  ['login-button-background-color', 'loginButtonBackground'],
  ['login-button-border-color', 'loginButtonBorder'],
  ['login-button-text-color', 'loginButtonText'],
  ['login-button-hover-background-color', 'loginButtonHoverBackground'],
  ['login-button-hover-border-color', 'loginButtonHoverBorder'],
  ['login-button-hover-text-color', 'loginButtonHoverText'],

  // Radiobutton
  ['radiobutton-selected-background-color', 'radioButtonSelectedBackground'],
  ['radiobutton-selected-border-color', 'radioButtonSelectedBorder'],

  // Other
  ['footer-background-color', 'footer'],
  ['header-background-color', 'header'],
  ['review-step-header-background-color', 'reviewStepHeader'],
  ['section-bar-background-color', 'sectionBar'],
  ['selection-background-color', 'selectionBackground'],
  ['progress-bar-color', 'progressBar'],

  // StepFooter
  ['step-footer-background-color', 'stepFooterBackground'],
  ['step-footer-border-color', 'stepFooterBorder'],
  ['step-footer-icon-color', 'stepFooterIconColor'],
];

export const STATE_NAME_TO_ABBREVIATION: { [stateName: string]: string } = {
  alabama: 'AL',
  alaska: 'AK',
  arizona: 'AZ',
  arkansas: 'AR',
  california: 'CA',
  colorado: 'CO',
  connecticut: 'CT',
  delaware: 'DE',
  florida: 'FL',
  georgia: 'GA',
  guam: 'GU',
  hawaii: 'HI',
  idaho: 'ID',
  illinois: 'IL',
  indiana: 'IN',
  iowa: 'IA',
  kansas: 'KS',
  kentucky: 'KY',
  louisiana: 'LA',
  maine: 'ME',
  maryland: 'MD',
  massachusetts: 'MA',
  michigan: 'MI',
  minnesota: 'MN',
  mississippi: 'MS',
  missouri: 'MO',
  montana: 'MT',
  nebraska: 'NE',
  nevada: 'NV',
  ohio: 'OH',
  oklahoma: 'OK',
  oregon: 'OR',
  pennsylvania: 'PA',
  tennessee: 'TN',
  texas: 'TX',
  utah: 'UT',
  vermont: 'VT',
  virginia: 'VA',
  washington: 'WA',
  wisconsin: 'WI',
  wyoming: 'WY',

  'american samoa': 'AS',
  'district of columbia': 'DC',
  'new hampshire': 'NH',
  'new jersey': 'NJ',
  'new mexico': 'NM',
  'new york': 'NY',
  'north carolina': 'NC',
  'north dakota': 'ND',
  'northern mariana islands': 'MP',
  'puerto rico': 'PR',
  'rhode island': 'RI',
  'south carolina': 'SC',
  'south dakota': 'SD',
  'virgin island': 'VI',
  'west virginia': 'WV',
};

export const STATES_EXCLUDED_FROM_FUNNELS = new Set(['vt', 'vermont']);

export const STATE_WITHOUT_FINANCING: { [abbreviation: string]: string } = {};

export const STATE_AND_TERRITORY_CODES = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'AS',
  'AE',
  'AP',
  'AA',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC',
  'FL',
  'GA',
  'GU',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'CM',
  'OH',
  'OK',
  'OR',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'TT',
  'UT',
  'VT',
  'VA',
  'VI',
  'WA',
  'WV',
  'WI',
  'WY',
];

export const RENT_OR_OWN_LABEL_MAP: Record<string, string> = {
  ownMortgage: 'Own with Mortgage',
  own: 'Own free and clear',
  rent: 'Rent',
  friend: 'With Relative/Friend',
  military: 'Military Residence',
};

/**
 * @deprecated Please use `FullAppOptimizeV1Flag.name` (i.e. the flag name made available in `featureFlags.ts`) instead of this constant
 */
export const FF_FULL_APPLICATION_V1 = 'ps-625-trident-fullapplication-optimizev1';
/**
 * @deprecated Please use `FullAppStylingFlag.name` (i.e. the flag name made available in `featureFlags.ts`) instead of this constant
 */
export const FF_FULL_APPLICATION_STYLING = 'ps-625-trident-fullapplication-new-styling';

export function isProduction(): boolean {
  return BUILD_ENV === 'production';
}

export function isTridentFunding(host: string): boolean {
  return host.includes('tridentfunding');
}

export function isBoatTrader(): boolean {
  return window.location.host.includes('boattrader');
}

export function isStage(): boolean {
  return BUILD_ENV === 'stage';
}

export function isDev(): boolean {
  return !isProduction() && !isStage();
}

export function getEnv() {
  return isProduction() ? 'prod' : 'dev';
}

export function getSalesforceSellerAccountListUrl(): string {
  if (isProduction()) return SALESFORCE_SELLER_ACCOUNT_LIST_URL_PROD;
  if (isStage()) return SALESFORCE_SELLER_ACCOUNT_LIST_URL_STAGE;
  return SALESFORCE_SELLER_ACCOUNT_LIST_URL_STAGE;
}

/**
 * get the name of a deployed function
 * On stage this would include the hash of the last deploy so preview urls work independently
 * @param base
 */
export function getCallableName(base: string): string {
  if (!isStage()) {
    return base;
  }
  return `${base}_${BUILD_DEPLOYED_VERSION.substring(0, 7)}`;
}

/**
 * the backend url for the "old app"
 */
export function getSwipBackendUrl(): string {
  if (isProduction()) {
    return 'https://app.tridentfunding.com';
  }
  return 'https://test.tridentfunding.com';
}

export const getLoanPurposeIndex = () => {
  const experimentIndex = isProduction() ? 10 : 3;
  return experimentIndex;
};

export const CUSTOM_DATA_INDICES = {
  IS_MARINE_PURPOSE: getLoanPurposeIndex(),
};

export const loanPageviewEvents = new Map([
  [undefined, undefined],
  ['', 'choose loan purpose'],
  ['type', 'choose loan purpose'],
  ['details', 'loan details page'],
  ['seller', 'seller details page'],
  ['collateral', 'collateral page'],
  ['finance', 'finance page'],
  ['refinance', 'refinance page'],
  ['cash-recapture', 'cash recapture page'],
  ['experience', 'experience page'],
  ['borrower', 'borrower page'],
  ['contact', 'borrower contact page'],
  ['address', 'borrower address page'],
  ['income', 'income page'],
  ['assets', 'assets page'],
  ['other-assets', 'other assets page'],
  ['liabilities', 'liability page'],
  ['real-state', 'real state page'],
  ['statement-summary', 'statement summary page'],
  ['employer', 'employer page'],
  ['previous-employer', 'previous employer page'],
  ['coborrower-income', 'coborrower income page'],
  ['coborrower-employer', 'coborrower employer page'],
  ['coborrower-previous-employer', 'coborrower previous employer page'],
  ['review', 'review page'],
  ['submit', 'submit page'],
  ['success', 'success page'],
]);

export const LEAD_SOURCE: ReadonlyMap<number, string> = new Map([
  [0, 'Trident Funding'],
  [101397, 'BoatUS'],
  [101442, 'YachtWorld'],
  [101458, 'Boattrader'],
  [101460, 'Boats.com'],
  [102565, 'Good Sam Finance Center'],
]);

// LendAPI Prequal V1 constants
export const LEND_API_PRODUCT_ID_QA = 634;
export const LEND_API_PRODUCT_ID_QA_UI = '4J97R91U_410';
export const LEND_API_PRODUCT_ID_PROD = 808;
export const LEND_API_PRODUCT_ID_PROD_UI = '5XLOAZEV_468';

// LendAPI FullApp constants
export const LEND_API_FULLAPP_PRODUCT_ID_QA = 626;
export const LEND_API_FULLAPP_PRODUCT_ID_PROD = 451;

export const getValidPrequalProductIds = (): number[] => {
  const env = isProduction() ? 'production' : 'qa';
  return getAllProducts(env)
    .filter((p) => p.productType === LendAPIProductType.prequal)
    .map((p) => p.productId);
};

export const getValidFullAppProductIds = (): number[] => {
  const env = isProduction() ? 'production' : 'qa';
  return getAllProducts(env)
    .filter((p) => p.productType === LendAPIProductType.fullApp)
    .map((p) => p.productId);
};

export const getValidCombinedProductIds = (): number[] => {
  const env = isProduction() ? 'production' : 'qa';
  return getAllProducts(env)
    .filter((p) => p.productType === LendAPIProductType.combined)
    .map((p) => p.productId);
};

// LendAPI Prequal constants
export enum LendApiPrequalTab {
  LETS_GET_STARTED = 'LetsGetStarted',
  FINANCING_DETAIL = 'FinancingDetail',
  DOWN_PAYMENT = 'DownPayment',
  ABOUT_YOU = 'AboutYou',
  SELECT_FICO = 'SelectFICO',
  RESULTS = 'Results',
  DECLINED = 'Declined',
  QUALIFIED = 'Qualified',
  UNQUALIFIED = 'Unqualified',
}

export enum LendApiFullAppTab {
  LETS_GET_STARTED = 'LetsGetStarted',
  PROFILE_1 = 'Profile1',
  PROFILE = 'Profile',
  HOME_ADDRESS = 'HomeAddress',
  CREDIT_CONSENT = 'CreditConsent',
  PREVIOUS_ADDRESS = 'PreviousAddress',
  JD_POWER = 'JDPower',
  BOAT_INFO_TRADE_IN = 'BoatInfo-TradeIn',
  BOAT_INFO_SELLER_INFO = 'BoatInfo-SellerInfo',
  LOAN_INFO = 'LoanInfo',
  INCOME = 'Income',
  INCOME_EMPLOYMENT = 'Income-YourEmploymentInformation',
  INCOME_LIQUID_RETIREMENT = 'Income-LiquidorRetirementAssets',
  INCOME_REAL_ESTATE = 'Income-RealEstate',
  INCOME_OTHER_ASSETS = 'Income-OtherAssets',
  INCOME_LIABILITIES = 'Income-Liabilities',
  INCOME_FINANCIAL_STATEMENT = 'Income-YourFinancialStatement',
  CONTACT_COBORROWER_INFO = 'Contact-YourCo-BorrowersInformation',
  CONTACT_COBORROWER_ADDRESS = 'Contact-Co-borrowersHomeAddress',
  CONTACT_COBORROWER_CONTACT = 'Contact-HowdowecontactyourCo-Borrower',
  CONTACT_COBORROWER_FINANCIAL = 'Weneedafewfinancialdetailsforyourco-borrower',
  CONFIRM = 'Confirm',
  SUBMITTED = 'Submitted',
}

export enum LendApiCombinedPrequalTab {
  LOAN_PURPOSE_NA = 'LoanPurpose-NA',
  LETS_GET_STARTED_NA = 'LetsGetStarted-NA',
  BOAT_DETAILS = 'BoatDetails',
  ABOUT_YOU_INDIVIDUAL = 'AboutYou-Individual',
  ABOUT_YOU_JOINT = 'AboutYou-Joint',
  SSN_SOFT_PULL = 'SSNSoftPull',
  SSN_SOFT_PULL_JOINT = 'SSNSoftPull-joint',
  RESULTS_NO_HIT_SOFT_PULL = 'Results-Nohitsoftpull',
  RESULTS_NO_OFFERS = 'Results-NoOffers',
  RESULTS_MANUAL_REVIEW_NO_OFFERS = 'Results-ManualReviewNoOffers',
  APPROVAL_ODDS_EXCELLENT = 'ApprovalOdds-Excellent',
  APPROVAL_ODDS_VERY_GOOD = 'ApprovalOdds-VeryGood',
  APPROVAL_ODDS_GOOD = 'Approvalodds-Good',
  APPROVAL_ODDS_FAIR = 'Approvalodds-Fair',
  APPROVAL_ODDS_POINTS = 'ApprovalOddsPoints',
  APPROVAL_ODDS_MANUAL_REVIEW = 'ApprovalOdds-ManualReview',
  APPROVAL_ODDS_NO_OFFERS = 'ApprovalOdds-NoOffers',
}

export enum LendApiCombinedFullAppTab {
  PREVIOUS_ADDRESS = 'PreviousAddress',
  CURRENT_ADDRESS = 'CurrentAddress',
  PRIMARY_PROFILE_NA = 'PrimaryProfile-NA',
  PROFILE_COBORROWER = 'Profile-Coborrower',
  MAILING_EQUALS_CURRENT = 'Mailingequalscurrentaddress',
  MAILING_ADDRESS = 'MailingAddress',
  CO_CURRENT_EQUALS_PRIMARY = 'CoCurrentequalsPrimaryCurrent',
  ADDRESS_COBORROWER = 'Address-Coborrower',
  PREVIOUS_ADDRESS_COBORROWER = 'PreviousAddress-Coborrower',
  BOAT_INFO_TRADE_IN = 'BoatInfo-TradeIn',
  LOAN_INFO = 'LoanInfo',
  INCOME = 'Income',
  INCOME_EMPLOYMENT = 'Income-YourEmploymentInformation',
  INCOME_LIQUID_RETIREMENT = 'Income-LiquidorRetirementAssets',
  INCOME_REAL_ESTATE = 'Income-RealEstate',
  INCOME_OTHER_ASSETS = 'Income-OtherAssets',
  COBORROWER_INCOME = 'CoBorrowerIncome',
  COBORROWER_EMPLOYMENT = 'CoBorrower-YourEmploymentInformation',
  COBORROWER_LIQUID_RETIREMENT = 'CoBorrower-LiquidorRetirementAssets',
  COBORROWER_REAL_ESTATE = 'CoBorower-RealEstate',
  COBORROWER_OTHER_ASSETS = 'CoBorrower-OtherAssets',
  PRIMARY_EMPLOYMENT = 'Primary-EmploymentInformation',
  PRIMARY_LIQUID_RETIREMENT = 'Primary-LiquidorRetirementAssets',
  PRIMARY_REAL_ESTATE = 'Primary-RealEstateAssets',
  PRIMARY_OTHER_ASSETS = 'Primary-OtherAssets',
  JD_POWER = 'JDPower',
  CREDIT_CONSENT = 'CreditConsent',
  CREDIT_CONSENT_PRIMARY_SSN = 'CreditConsent-PrimarySSN',
  SUBMITTED = 'Submitted',
}

export const LENDAPI_PREQUAL_TRACKING_EVENTS = {
  KAMELEOON_GOALS: {
    LETS_GET_STARTED: 'custom-lendapi-lets-get-started',
    RESULTS: 'custom-lendapi-results',
    UNQUALIFIED: 'custom-lendapi-unqualified',
  },
  GA_EVENTS: {
    PAGEVIEW: 'pageview',
    APPLICATION_SUBMITTED: 'application_submitted',
    DISQUALIFY_LEAD: 'disqualify_lead',
  },
} as const;

export const KAMELEOON_FULLAPP_FUNNEL_LOADED = 'custom-lendapi-fullapp-funnel-loaded';
export const KAMELEOON_COMBINED_FUNNEL_LOADED = 'custom-lendapi-combined-funnel-loaded';

export const COLLECTION_DISPLAY_NAMES: Record<string, string> = {
  colors: 'Colors',
  offices: 'Offices',
  salesReps: 'Sales Reps',
  settings: 'Settings',
  sources: 'Sources',
  theme: 'Theme',
};
